import SettingsPage from "../views/settings"

const features = () => {
  return <SettingsPage />
}
export default features
